// legalNewsActions.js
import { backendClient } from "../../api/backend";
import {
  FETCH_NEWS_REQUEST,
  FETCH_NEWS_SUCCESS,
  FETCH_NEWS_FAILURE,
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  FETCH_NEWS_ITEM_REQUEST,
  FETCH_NEWS_ITEM_SUCCESS,
  FETCH_NEWS_ITEM_FAILURE,
  FETCH_BOOKMARKS_REQUEST,
  FETCH_BOOKMARKS_SUCCESS,
  FETCH_BOOKMARKS_FAILURE,
  ADD_BOOKMARK_REQUEST,
  ADD_BOOKMARK_SUCCESS,
  ADD_BOOKMARK_FAILURE,
  REMOVE_BOOKMARK_REQUEST,
  REMOVE_BOOKMARK_SUCCESS,
  REMOVE_BOOKMARK_FAILURE,
  FETCH_PREFERENCES_REQUEST,
  FETCH_PREFERENCES_SUCCESS,
  FETCH_PREFERENCES_FAILURE,
  UPDATE_PREFERENCES_REQUEST,
  UPDATE_PREFERENCES_SUCCESS,
  UPDATE_PREFERENCES_FAILURE,
  FETCH_RECOMMENDATIONS_REQUEST,
  FETCH_RECOMMENDATIONS_SUCCESS,
  FETCH_RECOMMENDATIONS_FAILURE,
  SET_CURRENT_CATEGORY,
  SET_SEARCH_TERM,
  FETCH_NEWS_COUNTRIES_REQUEST,
  FETCH_NEWS_COUNTRIES_SUCCESS,
  FETCH_NEWS_COUNTRIES_FAILURE,
  FETCH_NEWS_REGIONS_REQUEST,
  FETCH_NEWS_REGIONS_SUCCESS,
  FETCH_NEWS_REGIONS_FAILURE,
  SET_SELECTED_COUNTRIES,
  SET_SELECTED_REGION,
  SET_DETECTED_COUNTRY,
} from "./types";

// Fetch news list without content - optimized for NewsHubScreen
export const fetchNews = (params = {}) => async (dispatch) => {
    dispatch({ type: FETCH_NEWS_REQUEST });

    try {
      const response = await backendClient.fetchNews(params);
      const items = response.items ?? response;
      const total = response.total ?? items.length;

      dispatch({
        type: FETCH_NEWS_SUCCESS,
        payload: { data: items, total },
      });

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_NEWS_FAILURE,
        payload: error.message,
      });
      throw error;
    }
  };
  
  // Fetch a single news item with full content - for NewsDetailScreen
  export const fetchNewsById = (newsId) => async (dispatch) => {
    dispatch({ type: FETCH_NEWS_ITEM_REQUEST });
    
    try {
      // This endpoint should now return the full news with content
      const data = await backendClient.fetchNewsItem(newsId);
      
      dispatch({
        type: FETCH_NEWS_ITEM_SUCCESS,
        payload: data,
      });
      
      return data;
    } catch (error) {
      dispatch({
        type: FETCH_NEWS_ITEM_FAILURE,
        payload: error.message,
      });
      throw error;
    }
  };

// Fetch a specific news item by ID
// export const fetchNewsItem = (newsId) => async (dispatch) => {
//   dispatch({ type: FETCH_NEWS_ITEM_REQUEST });
  
//   try {
//     const data = await backendClient.fetchNewsItem(newsId);
    
//     dispatch({
//       type: FETCH_NEWS_ITEM_SUCCESS,
//       payload: data,
//     });
    
//     return data;
//   } catch (error) {
//     dispatch({
//       type: FETCH_NEWS_ITEM_FAILURE,
//       payload: error.message,
//     });
//     throw error;
//   }
// };

// Fetch all available news categories
export const fetchCategories = () => async (dispatch) => {
  dispatch({ type: FETCH_CATEGORIES_REQUEST });
  
  try {
    const data = await backendClient.fetchCategories();
    
    dispatch({
      type: FETCH_CATEGORIES_SUCCESS,
      payload: data,
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: FETCH_CATEGORIES_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Fetch user's bookmarked news items
export const fetchBookmarks = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_BOOKMARKS_REQUEST });

  try {
    const response = await backendClient.fetchBookmarks(params);
    const items = response.items ?? response;
    const total = response.total ?? items.length;

    dispatch({
      type: FETCH_BOOKMARKS_SUCCESS,
      payload: { data: items, total },
    });

    return response;
  } catch (error) {
    dispatch({
      type: FETCH_BOOKMARKS_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Add a bookmark for a news item
export const addBookmark = (newsId) => async (dispatch) => {
  dispatch({ type: ADD_BOOKMARK_REQUEST });
  
  try {
    const data = await backendClient.addBookmark(newsId);
    
    dispatch({
      type: ADD_BOOKMARK_SUCCESS,
      payload: { ...data, news_id: newsId },
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: ADD_BOOKMARK_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Remove a bookmark
export const removeBookmark = (newsId) => async (dispatch) => {
  dispatch({ type: REMOVE_BOOKMARK_REQUEST });
  
  try {
    await backendClient.removeBookmark(newsId);
    
    dispatch({
      type: REMOVE_BOOKMARK_SUCCESS,
      payload: newsId,
    });
    
    return { success: true };
  } catch (error) {
    dispatch({
      type: REMOVE_BOOKMARK_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Fetch user's news preferences
export const fetchPreferences = () => async (dispatch) => {
  dispatch({ type: FETCH_PREFERENCES_REQUEST });
  
  try {
    const data = await backendClient.fetchPreferences();
    
    dispatch({
      type: FETCH_PREFERENCES_SUCCESS,
      payload: data,
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: FETCH_PREFERENCES_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Update user's news preferences
export const updatePreferences = (preferences) => async (dispatch) => {
  dispatch({ type: UPDATE_PREFERENCES_REQUEST });
  
  try {
    const data = await backendClient.updatePreferences(preferences);
    
    dispatch({
      type: UPDATE_PREFERENCES_SUCCESS,
      payload: data,
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: UPDATE_PREFERENCES_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Fetch personalized news recommendations
export const fetchRecommendations = (limit = 5) => async (dispatch) => {
  dispatch({ type: FETCH_RECOMMENDATIONS_REQUEST });
  
  try {
    const data = await backendClient.fetchRecommendations(limit);
    
    dispatch({
      type: FETCH_RECOMMENDATIONS_SUCCESS,
      payload: data,
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: FETCH_RECOMMENDATIONS_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Set current category filter
export const setCurrentCategory = (category) => ({
  type: SET_CURRENT_CATEGORY,
  payload: category,
});

// Set search term
export const setSearchTerm = (searchTerm) => ({
  type: SET_SEARCH_TERM,
  payload: searchTerm,
});

// Fetch available news countries
export const fetchNewsCountries = (language) => async (dispatch) => {
  dispatch({ type: FETCH_NEWS_COUNTRIES_REQUEST });
  try {
    const data = await backendClient.fetchNewsCountries(language);
    dispatch({ type: FETCH_NEWS_COUNTRIES_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: FETCH_NEWS_COUNTRIES_FAILURE, payload: error.message });
  }
};

// Fetch available news regions
export const fetchNewsRegions = (language) => async (dispatch) => {
  dispatch({ type: FETCH_NEWS_REGIONS_REQUEST });
  try {
    const data = await backendClient.fetchNewsRegions(language);
    dispatch({ type: FETCH_NEWS_REGIONS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: FETCH_NEWS_REGIONS_FAILURE, payload: error.message });
  }
};

// Timezone → country fallback map (same as landing page)
const TZ_COUNTRY_MAP = {
  'Africa/Casablanca': 'MA',
  'Asia/Dubai': 'AE',
  'Asia/Riyadh': 'SA',
  'Asia/Qatar': 'QA',
  'Asia/Bahrain': 'BH',
  'Asia/Kuwait': 'KW',
  'Asia/Muscat': 'OM',
  'Africa/Lagos': 'NG',
  'Africa/Accra': 'GH',
  'Africa/Abidjan': 'CI',
  'Africa/Dakar': 'SN',
  'Africa/Nairobi': 'KE',
  'Africa/Addis_Ababa': 'ET',
  'Africa/Dar_es_Salaam': 'TZ',
  'Africa/Kigali': 'RW',
  'Asia/Beirut': 'LB',
  'Asia/Amman': 'JO',
  'Asia/Baghdad': 'IQ',
  'Africa/Cairo': 'EG',
  'Europe/Paris': 'FR',
  'Europe/Berlin': 'DE',
};

// Fetch user's detected country from IP, fallback to timezone
export const fetchUserCountry = () => async (dispatch, getState) => {
  try {
    const data = await backendClient.fetchUserCountry();
    if (data?.country) {
      dispatch({ type: SET_DETECTED_COUNTRY, payload: data.country });
      dispatch({ type: SET_SELECTED_COUNTRIES, payload: [data.country] });
      return data;
    }
  } catch (error) {
    console.warn('Could not detect user country from IP:', error.message);
  }

  // Fallback: detect from timezone
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const detected = TZ_COUNTRY_MAP[tz];
    if (detected) {
      dispatch({ type: SET_DETECTED_COUNTRY, payload: detected });
      dispatch({ type: SET_SELECTED_COUNTRIES, payload: [detected] });
    }
  } catch { /* ignore */ }
};

// Set selected countries filter
export const setSelectedCountries = (countries) => ({
  type: SET_SELECTED_COUNTRIES,
  payload: countries,
});

// Set selected region filter
export const setSelectedRegion = (region) => ({
  type: SET_SELECTED_REGION,
  payload: region,
});